import "./App.css";
import Resume from "./pages/Resume";

function App() {
  return <Resume />;
}

export default App;
